module.exports = __webpack_public_path__ + "img/image009.b9949c60.jpg";